import PropTypes from "prop-types";
import GenericDialog from "../../../../../components/ui/dialogs/generic-dialog/GenericDialog";
import {Typography} from "@material-ui/core";

const TokenDescriptionDialog = (props) => {
    const dialogContent = (
        <>
            <Typography variant={"body2"}>
                {props.description}
            </Typography>
        </>
    )

    return (
        <GenericDialog open={props.open}
                       handleDialogClose={props.handleDialogClose}
                       dialogContent={dialogContent}
                       handleDialogCloseButton={props.handleDialogClose}
                       dialogWidth={"sm"}>
            <Typography variant={"h6"}>
                {props.title}
            </Typography>
        </GenericDialog>
    )
}

TokenDescriptionDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired,
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
}

export default TokenDescriptionDialog;
